import React, { useState, useEffect, useCallback } from "react";
import { Spinner } from "../../Components/Common/LoadingStates";
import { publishRewardsPrice, getRewardsPrice } from "../../helpers/fakebackend_helper";
import { AppPlacement, card, btnGhost, input, label, busyBtn, fmtNum, Muted, Stat, StatGrid, ReadOnlyNote } from "./shared";
import { apiError } from "./rewardsUtil";

export default function PriceTab({ flash, canPublish }) {
  const [price, setPrice] = useState("");
  const [week, setWeek] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [active, setActive] = useState(undefined); // undefined = loading, null = none

  const loadActive = useCallback(async () => {
    setActive(undefined);
    try {
      const r = await getRewardsPrice();
      setActive(r?.snapshot || null);
    } catch (err) {
      flash("error", apiError(err, "Failed to load current price"));
      setActive(null);
    }
  }, [flash]);
  useEffect(() => { loadActive(); }, [loadActive]);

  const submit = async (e) => {
    e.preventDefault();
    const p = Number(price);
    if (!Number.isFinite(p) || p <= 0) { flash("error", "Enter a positive price"); return; }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(week)) { flash("error", "Pick a week-start date"); return; }
    setBusy(true);
    try {
      const r = await publishRewardsPrice({ byb_price_usd: p, week_start: week });
      setResult(r);
      flash("success", `Published. Claim threshold is ${fmtNum(r?.threshold_points)} points.`);
      await loadActive();
    } catch (err) { flash("error", `Publish failed: ${apiError(err, "unknown error")}`); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div style={card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <h5 style={{ margin: 0 }}>Current claim threshold</h5>
          <button style={btnGhost} onClick={loadActive}>Refresh</button>
        </div>
        {active === undefined ? <Spinner /> : active === null ? (
          <Muted>No weekly price published yet. The claim threshold is 0 and claims are disabled until a price is set.</Muted>
        ) : (
          <StatGrid>
            <Stat label="Threshold (points)" value={fmtNum(active.threshold_points)} />
            <Stat label="WANK price (USD)" value={`$${active.byb_price_usd}`} />
            <Stat label="Week start" value={active.week_start} />
            <Stat label="Claim value" value="$100 of WANK" />
          </StatGrid>
        )}
      </div>

      <div style={card}>
        <h5 style={{ marginTop: 0 }}>Publish weekly WANK price</h5>
        <AppPlacement>the Rewards screen (claim threshold and valuation).</AppPlacement>
        {canPublish ? (
          <form onSubmit={submit} style={{ display: "grid", gap: 10, maxWidth: 420 }}>
            <input style={input} type="number" min="0" step="any" placeholder="WANK price (USD) *" value={price} onChange={(e) => setPrice(e.target.value)} />
            <label style={label}>Week start *
              <input style={input} type="date" value={week} onChange={(e) => setWeek(e.target.value)} />
            </label>
            <button style={busyBtn(busy)} disabled={busy}>Publish</button>
          </form>
        ) : (
          <ReadOnlyNote>Read only. Publishing the price needs the rewards.price permission.</ReadOnlyNote>
        )}
        {result && (
          <div style={{ marginTop: 14, color: "var(--bl-muted, #8b93a7)" }}>
            Week {result.week_start}: ${result.byb_price_usd} gives a claim threshold of <strong>{fmtNum(result.threshold_points)}</strong> points ($100 of WANK).
          </div>
        )}
        <p style={{ ...label, marginTop: 10 }}>
          Threshold = round($100 / price). Re-publishing the same week corrects its price.
        </p>
      </div>
    </div>
  );
}
